import { Routes } from "react-router";
import "./App.css";
import { createAppRoute, AppRoutes } from "./routes";

function App() {
  return (
    <Routes>
      {Object.values(AppRoutes).map((route) => createAppRoute(route))}
    </Routes>
  );
}

export default App;
